import { styled, SxProps, Theme } from '@mui/material';
import { TableDataCell } from './components/CaseDetails/CaseProcedure/AppealProcedureItem';

export const cancelButtonStyle: SxProps<Theme> = (t: Theme) => ({
    border: 1,
    padding: '0.5rem 0',
    width: '6rem'
});

export const saveButtonStyle: SxProps<Theme> = (t: Theme) => ({
    border: 1,
    padding: '0.5rem 0',
    width: '6rem',
    backgroundColor: t.palette.listItemButton.main,
    color: t.palette.primary.light,
    '&:hover': {
        backgroundColor: t.palette.listItemButton.hoverMain,
        '& .MuiListItemIcon-root': {
            color: t.palette.primary.light
        }
    }
});

export const grayedRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0.563rem 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem 0.063rem 0',
    borderColor: t.palette.globalSwitch.disabledBg,
    background: '#F2F2F2'
});

export const lastGrayedRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0.563rem 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg,
    background: '#F2F2F2'
});

export const medicalDeterminationRationaleRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0.563rem 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg,
    background: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column'
});

export const firstHeaderRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0.625rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem 0.063rem 0 0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg
});

export const requestedApprovedMobileBoxStyle: SxProps<Theme> = () => ({
    width: '50%',
    display: 'flex',
    flexDirection: 'column'
});

export const SemiBoldTableDataCell = styled(TableDataCell)({
    fontWeight: '600',
    padding: '16px',
    wordBreak: 'break-word'
});

export const reasonTextStyle: SxProps<Theme> = (t: Theme) => ({
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
    width: '10%'
});

export const medicalDeterminationRationaleTextStyle: SxProps<Theme> = (t: Theme) => ({
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.25rem'
});

export const headerRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0.375rem 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg
});

export const headerRowStyleFlex: SxProps<Theme> = (t: Theme) => ({
    padding: '0.375rem 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg,
    display: "flex",
    alignItems: "center",
    gap: "5px"
});

export const radioRowStyle: SxProps<Theme> = (t: Theme) => ({
    padding: '0 0.75rem',
    borderStyle: 'solid',
    borderWidth: '0 0.063rem',
    borderColor: t.palette.globalSwitch.disabledBg
});

export const borderRightStyle: SxProps<Theme> = (t: Theme) => ({
    borderRightStyle: 'solid',
    borderRightWidth: '0.125rem',
    borderRightColor: t.palette.globalSwitch.disabledBg,
    width: '50%'
});

export const backdropStyle: SxProps<Theme> = () => ({
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1
});

export const ancillaryHourFormControlStyle: SxProps<Theme> = () => ({
    margin: 1,
    minWidth: 120
});

export const addIconStyle: SxProps<Theme> = () => ({
    margin: 'auto 0.375rem'
});

export const editIconStyle: SxProps<Theme> = (t: Theme) => ({
    margin: 'auto 0.625rem',
    color: t.palette.primary.main
});

export const buttonBoxStyle: SxProps<Theme> = () => ({
    display: 'flex',
    margin: 'auto',
    minHeight: '2.5rem',
    alignItems: 'center'
});

export const regularTypographyStyle: SxProps<Theme> = () => ({
    fontWeight: 'bold',
    marginBottom: '0.625rem'
});

export const smallerTypographyStyle: SxProps<Theme> = () => ({
    fontSize: '0.813rem',
    fontWeight: 'bold',
    marginBottom: '0.625rem'
});

export const blueRibbonStyle: SxProps<Theme> = (t: Theme) => ({
    color: t.palette.primary.light,
    lineHeight: '2rem',
    textAlign: 'center',
    verticalAlign: 'middle'
});
